import React from "react";
import { Redirect, Route, Switch, Link } from "react-router-dom";
import { connect } from "react-redux";

import { auth } from "firebase/firebase";
import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userAnonSignIn,
  userSignUpAnon,
  userGithubSignIn,
  userGoogleSignIn,
  userSignIn,
  userSignInAnon,
  userTwitterSignIn,
} from "actions/Auth";
import CircularProgress from "components/CircularProgress";

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
    };
  }
  async componentDidMount() {
    //HACEMOS LOGIN ANONIMO

    var currentUser = auth.currentUser;

    //console.log("CURRENT USER", currentUser);

    if (!currentUser) {
      /*const user = await auth.signInAnonymously();

      if (user) {
        //console.log("ANON", user);
        //this.props.history.push("app/inicio/menu");
        //this.props.history.push("/app/inicio/menu");
      }*/
      //this.props.userAnonSignIn();
    } else {
      //this.props.history.push("app/inicio/menu");
    }
  }

  componentDidUpdate() {
    if (this.props.authUser !== null) {
      this.props.history.push("app/inicio/menu");
    }
  }

  render() {
    return (
      <div className="justify-content-center d-flex background-login">
        <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
          <CircularProgress />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userAnonSignIn,
  userGoogleSignIn,
  userGithubSignIn,
  userTwitterSignIn,
})(SignIn);



// WEBPACK FOOTER //
// ./containers/SignIn.js